import { Button } from '@mui/material';
import arrow from 'assets/img/arrowBtn.svg';
import { useEffect, useState } from 'react';

const BackToTopButtonModal = (props) => {
  const { topModalRef } = props;

  const scrollToTop = () => {
    topModalRef.current?.scrollIntoView({
      block: 'nearest',
      behavior: 'smooth'
    });
  };

  return (
    <>
      <Button
        onClick={scrollToTop}
        sx={{
          bottom: '40px',
          right: '30px',
          width: '40px',
          height: '40px',
          zIndex: '8',
          minWidth: '40px',
          position: 'absolute',
          bgcolor: '#FFFFFF !important',
          border: '1px solid #3CC0C3',
          borderRadius: '50%',
          transition: '0.3s ease-in-out'
        }}
      >
        <img src={arrow} style={{ rotate: '90deg' }} alt="" />
      </Button>
    </>
  );
};

export default BackToTopButtonModal;
